import { render } from "./InvioPDC.vue?vue&type=template&id=f8db61e0&scoped=true"
import script from "./InvioPDC.vue?vue&type=script&lang=js"
export * from "./InvioPDC.vue?vue&type=script&lang=js"

import "./InvioPDC.vue?vue&type=style&index=0&id=f8db61e0&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8db61e0"]])

export default __exports__